import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6074e59e&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6074e59e')) {
      api.createRecord('6074e59e', component.options)
    } else {
      api.reload('6074e59e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6074e59e&", function () {
      api.rerender('6074e59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/Accordion.vue"
export default component.exports